import type { LocalizationDictionary } from "@slot/game-shell";

// The game's words are split from the shell's (decision 40):
//   - shell.<locale>.json  the shell's own words (its controls, modals and the info page's shared sections), shipped
//                          and loaded by the shell.
//   - game.<locale>.json   this title's, in `assets-src/game-shared-visuals/localization/`, merged over the shell's:
//                          its feature panels, its offers, its info bodies and the info headings only its template
//                          reads.
//
// This file is the synchronous boot-time fallback for the game's strings the code reads before the JSON loads; its
// values are game.en.json's (the parity test holds them equal).

export const gameEnDictionary: LocalizationDictionary = {
  // the feature panels
  "featurefinished.subtitle": "in Free Spins",
  "featuretrigger.title": "You Have Won",
  "featuretrigger.subtitle": "Free Spins",
  "featuretrigger.amount": "You won {count} Free Spins",
  "featuretrigger.super_bonus_buy.title": "Super Bonus",
  "featuretrigger.super_bonus_buy.description": "Keeps the base game's mechanics — plus your best VS result is saved as the minimum for the next VS battle.",
  "featuretrigger.vs_rush_buy.title": "VS Rush",
  "featuretrigger.vs_rush_buy.description": "Keeps the base game's mechanics — plus VS battles drop far more often.",

  // the purchase offers
  "feature_purchase.super_bonus_buy.title": "Super Bonus Buy",
  "feature_purchase.super_bonus_buy.description": "Free spins where your best VS result is saved as the minimum for the next VS battle.",
  "feature_purchase.vs_rush_buy.title": "VS Rush",
  "feature_purchase.vs_rush_buy.description": "Free spins with VS battles dropping far more often.",
  "feature_purchase.bonus_hunt_mode.title": "Bonushunt Featurespins",
  "feature_purchase.bonus_hunt_mode.description": "Each spin is more likely to trigger a bonus game.",
  "feature_purchase.guaranteed_vs_mode.title": "Guaranteed VS",
  "feature_purchase.guaranteed_vs_mode.description": "At least one VS battle lands on every spin.",

  // info-page headings only this title's template reads (the shell's until decision 40)
  "info.specialSymbols.title": "SPECIAL SYMBOLS",
  "info.specialSymbols.body": "The following symbols are not part of the paytable. They provide feature behaviour instead of direct payouts.",
  "info.specialSymbols.scatter.title": "SCATTER",
  "info.specialSymbols.wild.title": "WILD",
  "info.paylines.title": "PAYLINES",
  "info.freeSpinsTrigger.title": "FREE SPINS TRIGGER",
  "info.freeSpins.title": "FREE SPINS",
};
